import APIClient from "../../common/APIClient";

export const SUCCESS_ALERT = "success";
export const ERROR_ALERT = "danger";
export const MAX_ITEMS_IN_PAGE = 10;

const SHOW_ALERT_MESSAGE = "SHOW_ALERT_MESSAGE";
const TOGGLE_DIALOG_BOX = "TOGGLE_DIALOG_BOX";
const TOGGLE_PROMPT = "TOGGLE_PROMPT";
const SET_WEEK_IN_YEAR = "SET_WEEK_IN_YEAR";
const UPDATE_CURRENT_STEP = "UPDATE_CURRENT_STEP";
const RESET_ACTIVE_STEP = "RESET_ACTIVE_STEP";
const SET_WIZARD_HAS_ERROR = "SET_WIZARD_HAS_ERROR";
const SET_SELECTED_USER_OPTION = "SET_SELECTED_USER_OPTION";
const CLEAR_SELECT_USER_OPTION = "CLEAR_SELECT_USER_OPTION";
const SET_IS_SAVING = "SET_IS_SAVING";
const RESET_IS_SAVING = "RESET_IS_SAVING";
const ERROR_API_TOKEN_REQUIRED = "ERROR_API_TOKEN_REQUIRED";

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
};

export const toggleShowAlert = (show, alertType, message) => {
  if (
    message === "Token is Expired" ||
    message === "Token has expired and can no longer be refreshed"
  )
    return null;

  return (dispatch) => {
    dispatch({ type: SHOW_ALERT_MESSAGE, show, alertType, message });
    //auto-close alert
    setTimeout(() => {
      dispatch({ type: SHOW_ALERT_MESSAGE, show: false });
    }, 4000);
  };
};

export const toggleDialogBox = (show) => {
  return (dispatch) => {
    dispatch({ type: TOGGLE_DIALOG_BOX, show });
  };
};

export const togglePrompt = (show) => {
  return (dispatch) => {
    dispatch({ type: TOGGLE_PROMPT, show });
  };
};

export const displayError = (error) => {
  return (dispatch) => {
    let errorMessage = "";
    let errorCode = "";
    if (typeof error.response !== "undefined") {
      let response = error.response;
      if (typeof response.data !== "undefined") {
        let errorData = response.data;
        if (errorData.message) {
          errorMessage = errorData.message;
          errorCode = errorData.code;
        } else if (errorData.status_message) {
          errorMessage = errorData.status_message;
        }
      } else {
        errorMessage = "An error occured while updating the user.";
      }
      if (errorCode === ERROR_API_TOKEN_REQUIRED) {
        window.location.href = "/";
      } else {
        dispatch(toggleShowAlert(true, ERROR_ALERT, errorMessage));
      }
    }
  };
};

export const getWeeksInYear = () => {
  return (dispatch) => {
    client()
      .get("filters/weeks-in-year")
      .then((json) => {
        const result = json.data;
        if (result) {
          const data = result.data;
          dispatch({ type: SET_WEEK_IN_YEAR, weeks: data });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const nextStep = (steps) => {
  return (dispatch, getState) => {
    let activeStep = getState().common.activeStep;
    if (activeStep <= steps.length) {
      activeStep++;
      dispatch({ type: UPDATE_CURRENT_STEP, step: activeStep });
    }
  };
};

export const prevStep = () => {
  return (dispatch, getState) => {
    let activeStep = getState().common.activeStep;
    if (activeStep > 0) {
      activeStep--;
      dispatch({ type: UPDATE_CURRENT_STEP, step: activeStep });
    }
  };
};

export const resetStep = () => {
  return (dispatch) => {
    dispatch({ type: RESET_ACTIVE_STEP });
  };
};

export const setWizardHasError = (hasError) => {
  return (dispatch) => {
    dispatch({ type: SET_WIZARD_HAS_ERROR, hasError });
  };
};

export const setSelectedUserOpt = (options) => {
  return (dispatch) => {
    dispatch({ type: SET_SELECTED_USER_OPTION, options });
  };
};

export const clearSelectedUserOpt = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_SELECT_USER_OPTION });
  };
};

export const setIsSaving = (isSaving) => {
  return (dispatch) => {
    dispatch({ type: SET_IS_SAVING, isSaving });
  };
};

export const resetIsSaving = () => {
  return (dispatch) => {
    dispatch({ type: RESET_IS_SAVING });
  };
};

export const nextPage = (
  dispatchType,
  min,
  max,
  currentPage,
  totalPages,
  numItems,
  callback = null
) => {
  return (dispatch) => {
    if (currentPage < totalPages) {
      min = min + MAX_ITEMS_IN_PAGE;

      if (numItems - max >= MAX_ITEMS_IN_PAGE) {
        max = max + MAX_ITEMS_IN_PAGE;
      } else {
        max = max + (numItems - max);
      }

      currentPage += 1;

      dispatch({
        type: dispatchType,
        numItems,
        min,
        max,
        totalPages,
        currentPage,
      });
      if (callback) {
        callback();
      }
    }
  };
};

export const prevPage = (
  dispatchType,
  min,
  max,
  currentPage,
  totalPages,
  numItems,
  callback = null
) => {
  return (dispatch) => {
    if (currentPage > 1) {
      min = min - MAX_ITEMS_IN_PAGE;

      if (currentPage === totalPages) {
        //last page
        let numLastItems = numItems - (currentPage - 1) * MAX_ITEMS_IN_PAGE;
        max = max - numLastItems;
      } else {
        max = max - MAX_ITEMS_IN_PAGE;
      }

      currentPage -= 1;

      dispatch({
        type: dispatchType,
        numItems,
        min,
        max,
        totalPages,
        currentPage,
      });
      if (callback) {
        callback();
      }
    }
  };
};

export const resetPagination = (dispatchType) => {
  return (dispatch) => {
    dispatch({ type: dispatchType });
  };
};
